export const DEFAULT_SHOP_ID=2
export const MAIN_IMAGE_TYPE = 'front'

export const LOCAL_STORAGE_KEY_BASKET = 'basket'

export const LOCAL_STORAGE_KEY_CUSTOMER = 'customer'

export const LOCAL_STORAGE_KEY_PARAMS = 'local-storage-params'



export const BASKET_POPUP_AUTOMATIC_DISAPPEAR = 5000;

export const FAVORITE_POPUP_AUTOMATIC_DISAPPEAR = 5000;

export const MAX_MODEL_PER_SEARCH = 4;

export const SEARCH_INPUT_DELAY = 1000;
export const SEARCH_INPUT_ADD_TO_HISTORY_DELAY = 3000;

// ------------ checkout  -----------

export const INTERNET_SHOP_ID = 2

export const VIRTUAL_SHOP_ID = '4'

export const VIRTUAL_MOSCOW_SHOP_ID = '5'

export const BASKET_SECONDS_BETWEEN_UPDATE_QUERY = 600

export const CREDIT_URL = 'https://api.7seconds.ru/home/forms?applicationId='

export const mailRuCounterId = '3239178'

export const VKPriceId = 178170;

export const NOT_FOUND_REPOSITORY_ID = '2949'

export const PAYMENT_TYPE_PODELI_ID = 'tsb-tso-000016'
export const PAYMENT_TYPE_CREDIT_CARD_ID = 'tsb-tst-000011'
export const PAYMENT_TYPE_CREDIT_ID = 'tsb-tso-000010'

export const MIN_SWIPE_DISTANCE = 50

export const MOSCOW_REGION_ID = 'tsb-tst-000001'
export const SPB_REGION_ID = 'tsb-tst-000095'